import { useQuery } from '@tanstack/react-query';
import { deploymentsApi, JobStatus } from '../api/deploymentsApi';

export const useDeploymentJobStatus = (
  deploymentId: string,
  jobId: string | null,
  options: { enabled?: boolean; refetchInterval?: number | false } = {}
) => {
  const { enabled = true, refetchInterval = false } = options;

  const {
    data,
    isLoading,
    error,
    refetch,
  } = useQuery<JobStatus>({
    queryKey: ['deployment-job-status', deploymentId, jobId],
    queryFn: () => deploymentsApi.jobStatus(deploymentId, jobId as string),
    enabled: enabled && !!deploymentId && !!jobId,
    refetchInterval,
  });

  return {
    status: data ?? null,
    isLoading,
    error: error as Error | null,
    refetch,
  };
};
